import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { P3 } from '@/frontend/design-system/typography/Paragraph';
import { cn } from '@/frontend/utils';
type ModuleButtonProps = {
  name: string;
  isOpen: boolean;
  isCurrentModule: boolean;
  onClick: () => void;
};
export function ModuleButton(t0) {
  const $ = _c(13);
  const {
    name,
    isOpen,
    isCurrentModule,
    onClick
  } = t0;
  const t1 = isCurrentModule && !isOpen ? "text-contentColorPrimary" : "";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex items-center justify-between gap-2 text-left text-contentSecondary", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isOpen ? "rotate-180" : "";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("h-4 w-4 shrink-0 text-current transition-transform duration-300", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <ChevronDownIcon className={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== name || $[7] !== t2 || $[8] !== t5) {
    t6 = <P3 className={t2}>{name}{t5}</P3>;
    $[6] = name;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onClick || $[11] !== t6) {
    t7 = <button type="button" className="w-full cursor-default rounded-lg px-2 py-4 hover:bg-backgroundHoverOverlay" onClick={onClick}>{t6}</button>;
    $[10] = onClick;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}